export const POLICY_PLACEHOLDER_COPY =
  "正式政策文本待运营方法务提供，上线前必须替换。";

export const POLICY_BUNDLE_PENDING_COPY =
  "发送验证码后将显示本次同意的政策版本。";

export function getLoginPolicyNotice(
  policies:
    | readonly { launchReady: boolean }[]
    | null
    | undefined,
): string | null {
  if (policies?.length !== 2) return POLICY_BUNDLE_PENDING_COPY;
  return policies.some((policy) => !policy.launchReady)
    ? POLICY_PLACEHOLDER_COPY
    : null;
}
